var _defs, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(255,255,255,0);}.b{fill:#ffffff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M78,163H66a1,1,0,0,0-1,1v8a1,1,0,0,0,1,1H78a1,1,0,0,0,1-1v-8A1,1,0,0,0,78,163Zm-.184,1.887L72,169.646l-5.816-4.759a.5.5,0,1,1,.632-.774L72,168.354l5.184-4.241a.5.5,0,1,1,.632.774Z",
    transform: "translate(-64 -160)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIconWhite);
export default __webpack_public_path__ + "static/media/contactIconWhite.26f1baefd79fd0a50d664532168ba6d1.svg";
export { ForwardRef as ReactComponent };